import 'intl'
import 'intl/locale-data/jsonp/en'

import { MainLoadingSkeleton } from 'components/Directories/Styled'
import { ResultsCountH3 } from './Styled'

const ResultsCount = ({ numOfResults, city, directoryLabel, isLoading }) => {
  const RESULTS_CAP = 10000 // Elasticsearch limits query results to 10,000 even when there may be more.
  const numberFormatter = new Intl.NumberFormat('en-US')
  const formattedNumOfResults = numberFormatter.format(numOfResults)

  // renders "X Location Housekeepers/Housekeeping Jobs etc. Found"
  // or "More than X Location Housekeepers/Housekeeping Jobs etc. Found" if results ocunt is 10,000 or more.
  return (
    (!isLoading && (
      <ResultsCountH3>
        {numOfResults >= RESULTS_CAP && 'More than'} {formattedNumOfResults}{' '}
        {city && city.charAt(0).toUpperCase() + city.slice(1)} {directoryLabel} Found
      </ResultsCountH3>
    )) || <MainLoadingSkeleton mt='20px' mb='24px' height='26px' maxWidth='330px' />
  )
}

export default ResultsCount
